module.exports = __webpack_public_path__ + "static/media/icons8-instagram2.41486f05.svg";